// extracted by mini-css-extract-plugin
module.exports = {"root":"GeneralConfigContainer-root-6046ad4ade2dcdefb52043f9df819070"};